import { TenantService } from "./tenant-service";

let tenantService = new TenantService();

export { tenantService };